import Grid from '@material-ui/core/Grid/Grid'
import Bus from 'EurestoClass/Bus'
import Utils from 'EurestoFonction/Utils'
import React from 'react'
import MarqueCategorie from '../../Component/Facturation/MarqueCategorie'
import MarqueIndice from '../../Component/Facturation/MarqueIndice'
import ModeEncaissement from '../../Component/Facturation/ModeEncaissement'
import ModeVente from '../../Component/Facturation/ModeVente'
import MotifOffert from '../../Component/Facturation/MotifOffert'
import PaxCategorie from '../../Component/Facturation/PaxCategorie'
import PointVente from '../../Component/Facturation/PointVente'
import RegroupementTaxe from '../../Component/Facturation/RegroupementTaxe'
import Remise from '../../Component/Facturation/Remise'
import TypeMarque from '../../Component/Facturation/TypeMarque'
import TypePointVente from '../../Component/Facturation/TypePointVente'





export default (class extends React.Component {

    state = {
        UserTabSelected: 0,
        busGUID: Utils.uuidv4()
    }

    crmConfiguration = [
        { nom: 'Type Point Vente', component: <TypePointVente /> },
        { nom: 'Point Vente', component: <PointVente /> },
        { nom: 'Remise', component: <Remise /> },
        { nom: 'Offert', component: <MotifOffert /> },
        { nom: 'Type de Marque', component: <TypeMarque /> },
        { nom: 'Marque Catégorie', component: <MarqueCategorie /> },
        { nom: 'Marque Indice', component: <MarqueIndice /> },
        { nom: 'Mode de Vente', component: <ModeVente /> },
        { nom: 'Catégorie Pax', component: <PaxCategorie /> },
        { nom: 'Regroupement de Taxe', component: <RegroupementTaxe /> },
        { nom: 'Mode d\'Encaissement', component: <ModeEncaissement /> },
    ]




    componentWillUnmount() {
        Bus.$off('donnees_annexes_facturation', this.state.busGUID)
    }

    componentDidMount() {
        Bus.$on('donnees_annexes_facturation', id => {
            this.setState({ UserTabSelected: id })
        }, this.state.busGUID)
    }

    render() {
        console.log(this.state.UserTabSelected, this.crmConfiguration[this.state.UserTabSelected])
        return <Grid container style={{ margin: 0, padding: 0, width: '100%', height: '100%' }} spacing={0}>
            <Grid item xs={12} key={this.state.UserTabSelected} style={{ margin: 0, padding: 0, width: '100%', height: '100%' }}>
                {
                    this.crmConfiguration[this.state.UserTabSelected].component
                }
            </Grid>
        </Grid>
    }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Facturation/index.js